import { render, staticRenderFns } from "./journalPromotion.vue?vue&type=template&id=b461853c&scoped=true"
import script from "./journalPromotion.vue?vue&type=script&lang=js"
export * from "./journalPromotion.vue?vue&type=script&lang=js"
import style0 from "./journalPromotion.vue?vue&type=style&index=0&id=b461853c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b461853c",
  null
  
)

export default component.exports